import { render } from "./DS360HomeView.vue?vue&type=template&id=865ba87e"
import script from "./DS360HomeView.vue?vue&type=script&lang=js"
export * from "./DS360HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__